var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4185 16 8 16C3.58154 16 0 12.4183 0 8C0 3.58173 3.58154 0 8 0C12.4185 0 16 3.58173 16 8ZM6.28027 5.21967C5.9873 4.92676 5.5127 4.92676 5.21973 5.21967C4.92676 5.51257 4.92676 5.98743 5.21973 6.28033L6.93945 8L5.21973 9.71967C4.92676 10.0126 4.92676 10.4874 5.21973 10.7803C5.5127 11.0732 5.9873 11.0732 6.28027 10.7803L8 9.06067L9.71973 10.7803C10.0127 11.0732 10.4873 11.0732 10.7803 10.7803C11.0732 10.4874 11.0732 10.0126 10.7803 9.71967L9.06055 8L10.7803 6.28033C11.0732 5.98743 11.0732 5.51257 10.7803 5.21967C10.4873 4.92676 10.0127 4.92676 9.71973 5.21967L8 6.93933L6.28027 5.21967Z",
    fill: "#54687D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCross);
export default __webpack_public_path__ + "static/media/filled-cross.be455317833ce7de4d5fa363e2c0f8cf.svg";
export { ForwardRef as ReactComponent };